import bgImage from "../images/afro-solar/financing/bg.webp";

const Financing = () => {
  return (
    <div
      style={{ backgroundImage: `url(${bgImage})`, backgroundSize: "cover" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="p-4 bg-white my-4 rounded">
              <h3 className="fs-24 gilroy-bold">OPEX Financing</h3>
              <ul className="fs-16">
                <li>Zero or minimal upfront payment</li>
                <li>Savings from Day 1 - Monthly outflow </li>
                <li>Much less than regular electricity bills</li>
                <li>Tenure – 5 - 25 years</li>
                <li>Asset can be in own name or financer's name</li>
                <li>No hassles of plant maintenance or insurance</li>
              </ul>
            </div>
            <div className="p-4 bg-white my-4 rounded">
              <h3 className="fs-24 gilroy-bold">OPEX Financing</h3>
              <ul className="fs-16">
                <li>Zero or minimal upfront payment</li>
                <li>Savings from Day 1 - Monthly outflow </li>
                <li>Much less than regular electricity bills</li>
                <li>Tenure – 5 - 25 years</li>
                <li>Asset can be in own name or financer's name</li>
                <li>No hassles of plant maintenance or insurance</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Financing;
